import CloseIcon from "@mui/icons-material/Close";
import { DialogTitle, IconButton, Typography } from "@mui/material";

const DialogHeader = ({ title, onClose }: { title: string; onClose?: () => void }) => {
    return (
        <DialogTitle sx={{ m: 0, p: 2, pb: 2 }}>
            <Typography variant="h4" sx={{ pl: 0 }}>
                {title}
            </Typography>
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: "absolute",
                        right: 12,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </DialogTitle>
    );
};

export default DialogHeader;
